import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { fetchData, getData } from "../components/firebase/firebase_methods";
import { databaseKey } from "../components/common/database_key";
import "../assets/css/ads-plans.css";
import PaymentOptions from "../components/payment_options";
import { useUpdatePaymentStatus } from "../components/donation/update_status";

const BannerPayment = () => {
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const navigate = useNavigate();
  const updatePaymentStatus = useUpdatePaymentStatus();

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const collectionName = databaseKey();
        const plansRef = fetchData(`${collectionName}/site_settings/ads_plan`);
        const snapshot = await getData(plansRef);

        if (snapshot.exists()) {
          const data = snapshot.val();
          const plansArray = Object.entries(data).map(([key, value]) => ({
            id: key,
            ...value,
          }));
          setPlans(plansArray);
        } else {
          console.log("No plans found.");
        }
      } catch (error) {
        console.error("Error fetching plans:", error);
      }
    };

    fetchPlans();
  }, []);

  const handleBuyNow = (plan) => {
    if (plan.amount === 0) {
      updatePaymentStatus(plan);
      navigate("/");
    } else {
      setSelectedPlan(plan);
    }
  };

  return (
    <>
      <main id="main">
        <div className="breadcrumbs" data-aos="fade-in">
          <div className="container">
            <h2>Payment</h2>
            <p>Select a plan and proceed to payment.</p>
          </div>
        </div>

        {selectedPlan ? (
          <PaymentOptions selectedPlan={selectedPlan} />
        ) : (
          <div className="plans-container">
            <h3 className="plan-heading">Available Plans</h3>
            <div className="plans-grid">
              {plans.map((plan) => (
                <div key={plan.id} className="plan-card">
                  <h4 className="plan-name">{plan.name}</h4>
                  <p className="plan-amount">Rs{plan.amount}</p>
                  <p className="plan-expiry">
                    {plan.expiry || "No expiry specified"} Days
                  </p>
                  <button
                    className="btn-buy-now"
                    onClick={() => handleBuyNow(plan)}
                  >
                    Buy Now
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}
      </main>
    </>
  );
};

export default BannerPayment;
